module.exports = "/_next/static/images/ItInfrastructureImage-1970288db5fb965ef8e674cb64770f5d.png.webp";